import type { OwnerRezWidget } from '@/pages/property-detail/types';

export const ownerRezWidgetsByPropertyId: Record<string, OwnerRezWidget[]> = {
  belvedere: [
    {
      kind: 'availability',
      propertyId: 'a3710b7afce94d9d871c183f51be0811',
      widgetType: 'THE BELVEDERE 6 Month Calendar - Multiple Month Calendar',
      widgetId: '5dee43a6c1eb4847b7587e684cfd1892',
    },
    {
      kind: 'booking',
      propertyId: 'a3710b7afce94d9d871c183f51be0811',
      widgetType: 'THE BELVEDERE - Inquiry Widget - Booking/Inquiry',
      widgetId: 'b266f71bf7f743249c12f82f6ae329b7',
    },
    {
      kind: 'reviews',
      propertyId: 'a3710b7afce94d9d871c183f51be0811',
      widgetType: 'REVIEWS - BELVEDERE - Reviews',
      widgetId: '11422ea31ebd4ef58e8d03ae91f1b164',
    },
  ],
  'hannahs-pearl': [
    {
      kind: 'availability',
      propertyId: '79a6b755fec847568293bdcd655c2a93',
      widgetType: "HANNAH'S PEARL - Multiple Month Calendar",
      widgetId: '2898c0d22f544851842f088b92aa140f',
    },
    {
      kind: 'booking',
      propertyId: '79a6b755fec847568293bdcd655c2a93',
      widgetType: "HANNAH'S PEARL - BOOKING INQUIRY - Booking/Inquiry",
      widgetId: 'ebf76726b4ef4951a40cdcc5992375c4',
    },
    {
      kind: 'reviews',
      widgetType: 'REVIEWS - HANNAHS PEARL - Reviews',
      widgetId: '949b1826f6c74378a110ab2b8403fa70',
    },
  ],
  'sea-dreams': [
    {
      kind: 'availability',
      propertyId: '044ecc145cbe4b13b71d9ddac0221af5',
      widgetType: 'SEA DREAMS - CALENDAR AVAILABILITY - Multiple Month Calendar',
      widgetId: '24db91c752d14fdeb685c56be013f318',
    },
    {
      kind: 'booking',
      propertyId: '044ecc145cbe4b13b71d9ddac0221af5',
      widgetType: 'SEA DREAMS - Booking/Inquiry',
      widgetId: 'cbd82a1584af43ba90ed41dfded69aa7',
    },
    {
      kind: 'reviews',
      propertyId: '044ecc145cbe4b13b71d9ddac0221af5',
      widgetType: 'REVIEWS - SEA DREAMS - Reviews',
      widgetId: 'a5161c8daa1d4da895bd541494bb3dd0',
    },
  ],
  'beach-beach-baby': [
    {
      kind: 'availability',
      propertyId: '5e7bd94efa3a4456ad9e590c9140ca9d',
      widgetType: 'CALENDAR - BEACH BEACH BABY - Multiple Month Calendar',
      widgetId: '20a89d636ee64da5948ca2c8512b20ec',
    },
    {
      kind: 'booking',
      propertyId: '5e7bd94efa3a4456ad9e590c9140ca9d',
      widgetType: 'BOOKING INQUIRY - BEACH BEACH BABY - Booking/Inquiry',
      widgetId: 'bc3005a62a264a6b884a8aced66ddfa8',
    },
  ],
  'bella-vita': [
    {
      kind: 'availability',
      propertyId: 'fa5a5db0f5a745c68c62e8c0101f5881',
      widgetType: 'BELLA VITA - Multiple Month Calendar',
      widgetId: '551604d48b57464895c543a761133d64',
    },
    {
      kind: 'booking',
      propertyId: 'fa5a5db0f5a745c68c62e8c0101f5881',
      widgetType: 'BELLA VITA - Booking/Inquiry',
      widgetId: '87ab348b115b4c29afb7d55f9f26870b',
    },
    {
      kind: 'reviews',
      propertyId: 'fa5a5db0f5a745c68c62e8c0101f5881',
      widgetType: 'REVIEWS - BELLA VITA - Reviews',
      widgetId: 'e2adb2391c2346e2ac7a1ae22eb96990',
    },
  ],
  'sunset-bungalow-30a': [
    {
      kind: 'availability',
      propertyId: 'f4707ee5bcee440495028f112c93b322',
      widgetType: 'SUNSET BUNGALOW - 6 MONTH CALENDAR - Multiple Month Calendar',
      widgetId: '81a956484e9c44f88f2b87eac853a8d7',
    },
    {
      kind: 'booking',
      propertyId: 'f4707ee5bcee440495028f112c93b322',
      widgetType: 'SUNSET BUNGALOW - INQUIRY - Booking/Inquiry',
      widgetId: '27184001cb734283bc57801b3c375dd4',
    },
  ],
};

export function ownerRezWidgetsForProperty(propertyId: string): OwnerRezWidget[] {
  return ownerRezWidgetsByPropertyId[propertyId] ?? [];
}
